import { render, staticRenderFns } from "./ManterAprovacaoSolicitacaoView.vue?vue&type=template&id=74295c9a"
import script from "./ManterAprovacaoSolicitacaoView.vue?vue&type=script&lang=js"
export * from "./ManterAprovacaoSolicitacaoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports